import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;
export interface KycCompletedAction extends Action<typeof actionTypes.SET_KYC_COMPLETED> {
    type: typeof actionTypes.SET_KYC_COMPLETED;
}
export interface KycErrorAction extends Action<typeof actionTypes.KYC_ERROR> {
    type: typeof actionTypes.KYC_ERROR;
}

export type KdkActions = KycErrorAction | KycCompletedAction;

export const kycError = (): KycErrorAction => ({
    type: actionTypes.KYC_ERROR,
});

export const kdkCompleted = (): KycCompletedAction => ({
    type: actionTypes.SET_KYC_COMPLETED,
});
